import Vue from 'vue/dist/vue.js';
import VisitSteps from './VisitSteps';
import VisitFirstStep from './VisitFirstStep';
import VisitTwoStep from './VisitTwoStep';
import VisitThreeStep from './VisitThreeStep';
import VisitFourStep from './VisitFourStep';
import VisitFiveStep from './VisitFiveStep';
import VisitThanksStep from './VisitThanksStep';
import VisitClose from './VisitClose';
import EventBus from './../event-bus';
import axios from 'axios';
import $ from 'jquery';

export default Vue.component('visit-app', {
  props: [
    'url_get_visit_post',
    'url_set_visit_post',
    'url_get_form_visit_post'
  ],
  components: {
    VisitSteps, 
    VisitClose,
    VisitFirstStep,
    VisitTwoStep,
    VisitThreeStep,
    VisitFourStep,
    VisitFiveStep,
    VisitThanksStep
  },
  data() {
    return {
      current_step: 1,
      salon_id: null,
      salon: {},
      type_space: null,
      visit: null,
      type_service: null,
      selected_date: null,
      
      visit_data: [
        'customer_fname',
        'customer_lname',
        'customer_email',
        'customer_phone',
      ],
    };
  },
  mounted() {
    EventBus.$on('SET_STEP', (payLoad) => {
      this.scrollTop();
      this.current_step = payLoad;
    });
    EventBus.$on('SET_SALON_ID', (payLoad) => {
      this.salon_id = payLoad;
      this.getVisits(payLoad);
    });
    EventBus.$on('SET_TYPE_SPACE', (payLoad) => {
      this.type_space = payLoad;
    });
    EventBus.$on('SET_TYPE_SERVICE', (payLoad) => {
      this.type_service = payLoad;
    });
    EventBus.$on('SET_CLIENT_DATA', (payLoad) => {
      this.visit_data[payLoad['field']] = payLoad['value'];
    });
    EventBus.$on('SET_VISIT', (payLoad) => {
      this.visit = payLoad;
    });
  },
  methods: {
    getVisits: function(salonId) {
      axios.post(this.url_get_visit_post, {
        salonId: salonId
      })
      .then( (response) => {
        this.salon = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    scrollTop() {
      document.querySelector('.visit-app').scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
});
